import React, { useState } from 'react';
import { useLanguage } from '../../LanguageContext';
import { Card, Row, Tabs, Tab } from "react-bootstrap";
import Artist from "./Artist";
import "../../styles/artists.css";
const Artists = () => {
    const { translations } = useLanguage();
    const [key, setKey] = useState('DeK');

    const DeK = translations.Artists.find(a => a.name.toLowerCase() === "de klamoja");

    return (
        <Card className="section-card">
            <Card.Body>
                <Card.Title>
                    <h1>{translations.Artist.title}</h1>
                </Card.Title>
                <Card.Text>
                    <Tabs
                        id="artist-tabs"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        className="mb-3"
                        fill
                    >

                        <Tab eventKey="DeK" title="De Klamoja">
                            <Row>
                                <Artist artist={DeK} />
                            </Row>
                        </Tab>
                    </Tabs>
                </Card.Text>
            </Card.Body>
        </Card>
    );
};

export default Artists;